module.exports = __webpack_public_path__ + "img/message-dark-solid.d8a08fc5.svg";